<template>
    <div class="container">
        <div class="banner">
            <img src="@/assets/information/banner.png" alt="">
            <div class="banner-text">
                <p class="banner-title">品牌资讯</p>
                <!-- <p class="banner-entitle">INFORMATION</p> -->
            </div>
        </div>
        <div class="tab-content">
            <ul class="tab-list">
                <li class="tab-item" v-for="(item,index) in tabList" :key="index" @click="changeTab(item.flag)">
                    <div :class="{'tab-item-wrap':true, 'active-tab':activeTab -1 === item.flag}">
                        <i :class="'tab-item-img tab-item-'+(index+1)"></i>
                        <div class="tab-item-text">
                            <div>{{ item.title }}</div>
                            <!-- <div class="tab-subtitle">{{ item.entitle }}</div> -->
                        </div>
                    </div>
                </li>
            </ul>
            <div class="swiper-tabs-wrap">
                <div class="swiper-tabs">
                    <div class="swiper-tab-wrap" v-for="(item,index) in dataList">
                        <div class="swiper-tab" @click="openNewWind(item)">
                            <div class="swiper-img">
                                <!-- <video-player v-show="activeTab === 1 || activeTab === 4" class="vjs-custom-skin" :options="item.options"></video-player> -->
                                <i v-show="item.newsPic && item.newsVideo" class="icon-play"><img src="@/assets/icon/icon_player.png" alt=""></i>
                                <img :src="item.newsPic" alt="">
                                <!-- <img v-show="activeTab === 2 || activeTab === 3" :src="item.newsPic" alt=""> -->
                            </div>
                            <!-- <div v-show="activeTab === 2 || activeTab === 3" class="swiper-img">
                                <img :src="item.newsPic" alt="">
                            </div> -->
                            <div class="swiper-tab-text">
                                <div class="swiper-tab-title" :title="item.newsTitle">{{ item.newsTitle }}</div>
                                <div :class="{ 'swiper-tab-date':true}">{{ item.newsTime }}</div>
                                <div class="swiper-tab-detail" :title="item.newsContent"><div>{{ item.newsContent }}</div></div>
                                <div v-show="activeTab === 2 || activeTab === 3" class="detail-btn"><div>查看详情</div></div>
                            </div>
                        </div>
                    </div>
                    <i class="swiper-icon-el swiper-icon-left" @click="goPage(-1)"></i>
                    <i class="swiper-icon-el swiper-icon-right" @click="goPage(1)"></i>
                </div>
                <div class="swiper-pagination"></div>
                <paginationView :dataObj="{total:page.total,pageSize:page.size,currPage:page.current}"
                    @queryPage="queryPage"></paginationView>
            </div>
        </div>
        <div v-if="dialogVisible" class="fixed-video-wrap" @click="closeDialog">
            <div class="fixed-video-container" @click.stop="">
                <video-player class="vjs-custom-skin" :options="playerOptions"></video-player>
            </div>
        </div>
    </div>
</template>
<script>
    import "video.js/dist/video-js.css";
    import "vue-video-player/src/custom-theme.css";
    import paginationView from '@/components/pagination-view';
    // import 'videojs-contrib-hls.js/src/videojs.hlsjs';
    export default {
        components:{paginationView},
        data(){
            return {
                tabList:[
                    // {title:'对话创始人',entitle:'Dialog',flag:1},
                    {title:'品牌动向',entitle:'Brand Trend',flag:1},
                    {title:'新闻资讯',entitle:'Enterprise News',flag:2},
                    {title:'加盟商故事',entitle:'Franchisee Story',flag:3}
                ],
                activeTab:1,
                playerOptions: {
                    height: "auto",
                    width: "100%",
                    playbackRates: [], // 可选的播放速度
                    autoplay: true, // 如果为true,浏览器准备好时开始回放
                    muted: false, // 默认情况下静音播放
                    loop: false, // 是否视频一结束就重新开始
                    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据，auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: "zh-CN",
                    aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小，换句话说，它将按比例缩放以适应其容器
                    sources: [
                    {
                        type: "video/mp4", // 类型
                        src: 'https://zymls-os.oss-cn-guangzhou.aliyuncs.com/images/10月13日.mp4_1699606591493', // url地址，在使用本地的资源时，需要用require()引入，否则控制台会报错
                    },
                    ],
                    poster: require('@/assets/information/banner.png'), // 设置封面地址
                    notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息
                    controlBar: {
                    currentTimeDisplay: true,
                    progressControl: true,  // 是否显示进度条
                    playbackRateMenuButton: true, // 是否显示调整播放倍速按钮
                    timeDivider: false, // 当前时间和持续时间的分隔符
                    durationDisplay: false, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true, // 是否显示全屏按钮
                    },
                },
                videoList:[],
                page:{
                    total:0,
                    size:3,
                    current:1
                },
                dataList:[],
                dialogVisible:false
            }
        },
        watch:{
            $route(to,from){
                let index = 0;
                if(to.query.block){
                    index = this.filterFlag(to.query.block)
                }else{
                    index = 0;
                }
                this.changeTab(index);
            }
        },
        mounted(){
            let index = this.filterFlag(this.$route.query.block);
            this.changeTab(index);
            // this.getData();
        },
        methods:{
            changeTab(index){
                console.log(index, 'index')
                this.activeTab = index + 1;
                this.page.total = 0;
                this.page.current = 1;
                this.getData();
            },
            getData(){
                console.log(this.activeTab)
                let size = this.activeTab == 3 ? 9 : this.page.size;
                const url = this.$WEBSITE_URL_OBJECT.news+'?newsType='+this.activeTab+'&current='+this.page.current+'&size='+ size
                this.$axios.get(url).then(res=>{
                    if(res.data.code === 0 ){
                        const blockedIds = [128, 129, 123, 114, 107, 100, 99, 98, 106, 75];

                        // 原始数据
                        const allRecords = res.data.data.records;

                        // 初始化数据列表
                        const finalList = [];
                        let i = 0;

                        // 遍历所有记录，过滤掉被屏蔽的，同时保证最终列表长度为3条（或更少如果数据不够）
                        while (finalList.length < 3 && i < allRecords.length) {
                        const item = allRecords[i];
                        if (!blockedIds.includes(item.id)) {
                            let obj = JSON.parse(JSON.stringify(this.playerOptions));
                            obj.sources[0].src = item.newsVideo;
                            obj.poster = item.newsPic || require('@/assets/information/banner.png');
                            item.options = obj;
                            item.newsTime = item.newsTime ? item.newsTime.split(' ')[0] : '';
                            finalList.push(item);
                        }
                        i++;
                        }

                        this.dataList = finalList;

                        this.page.total = res.data.data.total;
                        // if(this.activeTab == 1){
                        //     this.dataList.splice(1,1) // 2025年1月2日 黄奇手动去掉第二个视频
                        // }
                    }else{
                        this.dataList = [];
                        this.page.total = [];
                    }
                }).catch(err=>{
                    console.log(err);
                    this.dataList = [];
                    this.page.total = [];
                }).finally(()=>{
                    
                })
            },
            queryPage(arg){
                this.page.current = arg.current;
                this.getData();
            },
            goPage(flag){
                let totalPage = this.activeTab == 3 ? Math.ceil(this.page.total/9) : Math.ceil(this.page.total/this.page.size);
                let curr = this.page.current + flag;
                if(curr<1 || curr > totalPage){
                    return;
                }
                this.queryPage({current:curr});
            },
            openNewWind(item){
                if(item.newsLink && !item.newsVideo){
                    window.open(item.newsLink,'_blank')
                }else if(item.newsVideo){
                    this.dialogVisible = true;
                    this.playerOptions.sources[0].src = item.newsVideo;
                }
            },
            closeDialog(){
                this.dialogVisible = false;
            },
            filterFlag(str){
                let index = 1;
                switch(str){
                    case 'dhcsr':index = 0;break;
                    case 'ppdx':index = 1;break;
                    case 'qyxw':index = 2;break;
                    case 'jmsgs':index = 3;break;
                    default:index = 1;
                }
                return index;
            }
        }
    }
</script>
<style scoped src="./index.css"></style>


// WEBPACK FOOTER //
// src/view/information/index.vue